const { isRealObj } = require('./common');

const LogLevel = {
    Verbose: 5,
    Debug: 4,
    Info: 3,
    Warn: 2,
    Error: 1
}

const LogLevelNames = {
    [LogLevel.Verbose]: 'verbose',
    [LogLevel.Debug]: 'debug',
    [LogLevel.Info]: 'info',
    [LogLevel.Warn]: 'warn',
    [LogLevel.Error]: 'error',
}

const logLevelMatchers = Object.keys(LogLevel).map(name => ({ level: LogLevel[name], stringName: LogLevelNames[LogLevel[name]], matcher: new RegExp(name, 'i') }));

const getLevelByName = levelName => (logLevelMatchers.find(level => level.matcher.test(levelName)) || {}).level;

const DEFAULT_PRIMARY_COLOR = 'blue';
const LogLevelPrimaryColors = {
    Default: DEFAULT_PRIMARY_COLOR,
    [LogLevel.Verbose]: DEFAULT_PRIMARY_COLOR,
    [LogLevel.Debug]: DEFAULT_PRIMARY_COLOR,
    [LogLevel.Info]: DEFAULT_PRIMARY_COLOR,
    [LogLevel.Warn]: DEFAULT_PRIMARY_COLOR,
    [LogLevel.Error]: 'red',
}

/**
 * Cleans undefined properties from the given object. Useful to minimize log noise.
 *
 * @param {object} obj - any arbitrary object to clean undefs from
 */
const cleanUndefs = (obj, visited = []) => {
    if (visited.includes(obj)) { return obj; }

    if (Array.isArray(obj)) { return obj.map(item => cleanUndefs(item, visited)); }

    if (!isRealObj(obj)) { return obj };

    visited.push(obj);

    const clonedObj = { // do not muck about with the source references for logging
        ...obj,
    };
    // For Error instances, explictly copy stack & message
    // We need this because they're not enumerable by default
    if (obj instanceof Error) {
        clonedObj.message = obj.message;
        clonedObj.stack = obj.stack;
    }
    const keys = Object.keys(obj);
    keys.forEach(key => {
        const val = obj[key];
        if (val === undefined || typeof val === 'function') { // breaking change 4.2 - exclude functions from log obj copy
            return delete clonedObj[key];
        }
        // recursively clean
        const subObj = cleanUndefs(val, visited);
        if (isRealObj(subObj) && Object.keys(subObj).length === 0) {
            return delete clonedObj[key];
        }
        clonedObj[key] = subObj;
    })
    return clonedObj;
}

module.exports = {
    LogLevel,
    LogLevelNames,
    LogLevelPrimaryColors,
    getLevelByName,

    cleanUndefs,
}